import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const UerpCtaBanner: React.FC = () => (
  <section className="wdev-cta" aria-labelledby="uerp-cta-title">
    <div className="container">
      <AnimatedSection>
        <motion.div className="wdev-cta__inner" whileHover={{ scale: 1.005 }} transition={{ duration: 0.3 }}>
          <div className="wdev-cta__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M12 3L2 8l10 5 10-5-10-5z" stroke="#2563eb" strokeWidth="1.5" strokeLinejoin="round" />
              <path d="M6 11v5c0 2 2.5 4 6 4s6-2 6-4v-5" stroke="#2563eb" strokeWidth="1.5" />
            </svg>
          </div>
          <div className="wdev-cta__text">
            <h2 id="uerp-cta-title" className="wdev-cta__title">
              Ready to Digitise Your Institution?
            </h2>
            <p className="wdev-cta__subtitle">
              Get a demo of our University, Institution &amp; College ERP — admissions to alumni in one platform.
            </p>
          </div>
          <Link to="/contact" className="wdev-cta__btn">
            Get In Touch
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M3 8h10M9 4l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </motion.div>
      </AnimatedSection>
    </div>
  </section>
);

export default UerpCtaBanner;
